import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, ButtonGroup, Col, Label, Row } from 'reactstrap';
import { AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';
import { createEntity, getEntity, reset, updateEntity } from './patient.reducer';
import { getVillagesByCountry as getVillages } from 'app/entities/village/village.reducer';
import VillageAvTypeahead from 'app/shared/layout/menus/village-av-typeahead';
import {
  getMasterEntitiesByEnumNames,
  getMasterEntitiesByGroupNames,
  reset as resetWatotoCareEntities
} from 'app/entities/watotocare-entity/watotocare-entity.reducer';
import { IWatotoCareEntityDetail } from 'app/shared/model/watotocare-entity-detail.model';
import { IWatotoCareEntityMaster } from 'app/shared/model/watotocare-entity-master.model';
import { IWatotoCareEntityDto } from 'app/shared/model/watotocare-entity-dto.model';
import WatotocareEntityFormGroup from 'app/shared/components/watotocare-entity-form/watotocare-entity-form-group';
import { useTranslation } from 'app/shared/util/translation-utils';

export interface IPatientUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const PatientUpdate = (props: IPatientUpdateProps) => {
  const { t } = useTranslation();
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);
  const [countryId, setCountryId] = useState(null);
  const [villageId, setVillageId] = useState(null);
  const {
    patientEntity,
    watotoCareEntityList,
    watotoCareEntitiesByGroup,
    villages,
    userCountryId,
    villagesLoading,
    loading,
    updating
  } = props;
  const [villageNames, setVillageNames] = useState([]);
  const [consentStatus, setConsentStatus] = useState(null);
  const [eligibilityStatus, setEligibilityStatus] = useState(null);
  const [overrideWcId, setOverrideWcId] = useState('No');
  const patientParity = ['1', '2', '3', '4+'];

  const [ageRangeEntityDetails, setAgeRangeEntityDetails] = useState<IWatotoCareEntityDetail[]>([]);

  const [noConsentReasonMasterEntities, setNoConsentReasonMasterEntities] = useState<IWatotoCareEntityMaster[]>([]);
  const [ineligibilityReasonMasterEntities, setIneligibilityReasonMasterEntities] = useState<IWatotoCareEntityMaster[]>([]);
  const [patientEnrollmentMasterEntities, setPatientEnrollmentMasterEntities] = useState<IWatotoCareEntityMaster[]>([]);
  const [entityFormInitialValues, setEntityFormInitialValues] = useState<IWatotoCareEntityDto[]>([]);
  const [entityFormSelectedValues, setEntityFormSelectedValues] = useState<IWatotoCareEntityDto[]>([]);

  const WATOTOCARE_ENTITY_ENUM_NAMES = ['AGE_RANGE', 'NO_CONSENT_REASON', 'INELIGIBILITY_REASON'];
  const WATOTOCARE_ENTITY_GROUP_NAME = 'PATIENT_ENROLLMENT';

  const villageOptionList = () => {
    return (villageNames.length > 0) ? villageNames : ([{
      short: '',
      full: '',
      id: undefined,
      latitude: 0,
      longitude: 0
    }]);
  };

  const handleClose = () => {
    props.history.push('/patient');
  };

  const addBaby = () => {
    props.history.push('/patient-baby/create?parentId=' + patientEntity.id);
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (!isNew && patientEntity.countryId && patientEntity.countryId !== userCountryId) {
      alert('You don\'t have access to view this patient');
      handleClose();
    }
    setCountryId(userCountryId);

    if (!isNew && !patientEntity?.wcId?.toUpperCase().startsWith('WC')) {
      setOverrideWcId('Yes');
    }

    if (!isNew && typeof patientEntity.consent !== 'undefined') {
      setConsentStatus(patientEntity?.consent);
      setEligibilityStatus(patientEntity?.eligible);
    }

    setVillageId(patientEntity?.village?.id);
    props.getMasterEntitiesByEnumNames(WATOTOCARE_ENTITY_ENUM_NAMES, userCountryId);
    props.getMasterEntitiesByGroupNames([WATOTOCARE_ENTITY_GROUP_NAME], userCountryId);
    props.getVillages(undefined, undefined, undefined, userCountryId);

  }, [patientEntity, userCountryId]);

  useEffect(() => {
    if (watotoCareEntityList.length > 0) {
      // set watotoCareEntityDetails for each entity
      const ageRangeEntity = watotoCareEntityList.find(entity => entity.enumName === 'AGE_RANGE');
      if (ageRangeEntity) {
        setAgeRangeEntityDetails(ageRangeEntity.watotoCareEntityDetails
          .filter(entity => entity.isActive)
          .sort((a, b) => a.displayOrder - b.displayOrder)
        );
      }

      const noConsentReasonEntity = watotoCareEntityList.find(entity => entity.enumName === 'NO_CONSENT_REASON');
      if (noConsentReasonEntity) {
        setNoConsentReasonMasterEntities([noConsentReasonEntity]);
      }

      const ineligibilityReasonEntity = watotoCareEntityList.find(entity => entity.enumName === 'INELIGIBILITY_REASON');
      if (ineligibilityReasonEntity) {
        setIneligibilityReasonMasterEntities([ineligibilityReasonEntity]);
      }
    }
  }, [watotoCareEntityList]);

  useEffect(() => {
    if (patientEntity.id) {
      setEntityFormInitialValues(patientEntity.patientEnrollmentEntities);
    }
  }, [patientEntity]);


  useEffect(() => {
    if (Object.keys(watotoCareEntitiesByGroup).length > 0) {
      setPatientEnrollmentMasterEntities(watotoCareEntitiesByGroup[WATOTOCARE_ENTITY_GROUP_NAME]);
    }
  }, [watotoCareEntitiesByGroup]);


  const filterVillageByCountry = () => {
    const villagesNames = villages.map(item => ({
      short: item.name,
      council: item?.council?.name,
      district: item?.council?.parent?.name,
      country: item?.council?.parent,
      latitude: item?.locationLat,
      longitude: item?.locationLon,
      full: (item.name + ' / ' + item?.council?.name + ' / ' + item?.council?.parent?.name),
      id: item.id
    }));
    setVillageNames(villagesNames);
  };

  useEffect(() => {
    filterVillageByCountry();
  }, [countryId, villages]);

  useEffect(() => {
    if (props.updateSuccess) {
      if (consentStatus === true && isNew) {
        addBaby();
      } else {
        handleClose();
      }
    }
  }, [props.updateSuccess]);

  useEffect(() => {
    if (props.errorMessage) {
      alert(props.errorMessage);
    }
  }, [props.errorMessage]);

  const saveEntity = (event, errors, values) => {
    // remove blank values
    const filteredValues = { ...values };
    Object.keys(filteredValues).forEach((key) => filteredValues[key] === '' && delete filteredValues[key]);
    if (errors.length === 0) {
      const cid = isNew ? countryId : patientEntity.countryId;

      if (eligibilityStatus === true) {
        filteredValues.ineligibilityComment = null;
      }
      if (consentStatus === true) {
        filteredValues.noConsentComment = null;
      }

      const entity = {
        ...patientEntity,
        ...filteredValues,
        villageId,
        consent: consentStatus,
        eligible: eligibilityStatus,
        countryId: cid,
        patientEnrollmentEntityIds: entityFormSelectedValues
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  useEffect(() => () => {
    props.reset();
    props.resetWatotoCareEntities();
    setPatientEnrollmentMasterEntities([]);
    setEntityFormInitialValues([]);
    setEntityFormSelectedValues([]);
  }, []);

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="watotocareApp.patient.home.createOrEditLabel">{isNew ? t('patient.home.createOrEditLabel') : t('patient.home.editLabel')}</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>{t('common.loading')}</p>
          ) : (
            <AvForm model={isNew ? {} : patientEntity} onSubmit={saveEntity}>
              <div>
                <h5 className="text-primary mt-3">{t('patient.update.eligibilityTitle')}</h5>
                <div>
                  <AvGroup>
                    <Label id="eligibility" for="patient-eligibility">
                      {t('patient.update.eligibilityLabel')}
                    </Label>
                    <ButtonGroup style={{ marginLeft: '30px' }}>
                      <Button
                        color={eligibilityStatus === true ? 'primary' : 'secondary'}
                        value={eligibilityStatus}
                        onClick={() => {
                          setEligibilityStatus(true);
                        }}
                      >
                        {t('common.yes')}
                      </Button>

                      <Button
                        color={eligibilityStatus === false ? 'primary' : 'secondary'}
                        value={eligibilityStatus}
                        onClick={() => {
                          setEligibilityStatus(false);
                        }}
                      >
                        {t('common.no')}
                      </Button>
                    </ButtonGroup>
                  </AvGroup>
                  {eligibilityStatus === false && (
                    <>
                      <WatotocareEntityFormGroup
                        prefix="patient-ineligibility"
                        entities={ineligibilityReasonMasterEntities}
                        initialValues={entityFormInitialValues}
                        onChange={(values) => setEntityFormSelectedValues(values)}
                      />

                      <Row className="justify-content-left mt-2">
                        <Col md="6">
                          <AvGroup>
                            <Label id="ineligibilityComment" for="patient-ineligibilityComment">
                              {t('common.fields.comments')}
                            </Label>
                            <AvField
                              id="patient-ineligibilityComment"
                              type="text"
                              name="ineligibilityComment"
                              placeholder="if other, please specify"
                            />
                          </AvGroup>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              </div>

              {eligibilityStatus === false && <br />}

              {eligibilityStatus !== null && (
                <>
                  <div>
                    <h5 className="text-primary mt-3">{t('patient.update.consentTitle')}</h5>
                    <div>
                      <AvGroup>
                        <Label id="consent" for="patient-consent">
                          {t('patient.update.consentLabel')}
                        </Label>
                        <ButtonGroup style={{ marginLeft: '30px' }}>
                          <Button
                            color={consentStatus === true ? 'primary' : 'secondary'}
                            value={consentStatus}
                            onClick={() => {
                              setConsentStatus(true);
                            }}
                          >
                            {t('common.yes')}
                          </Button>

                          <Button
                            color={consentStatus === false ? 'primary' : 'secondary'}
                            value={consentStatus}
                            onClick={() => {
                              setConsentStatus(false);
                            }}
                          >
                            {t('common.no')}
                          </Button>
                        </ButtonGroup>
                      </AvGroup>
                      {consentStatus === false && (
                        <>
                          <WatotocareEntityFormGroup
                            prefix="patient-no-consent"
                            entities={noConsentReasonMasterEntities}
                            initialValues={entityFormInitialValues}
                            onChange={(values) => setEntityFormSelectedValues(values)}
                          />
                          <Row className="justify-content-left mt-2">
                            <Col md="6">
                              <AvGroup>
                                <Label id="noConsentComment" for="patient-noConsentComment">
                                  {t('common.fields.comments')}
                                </Label>
                                <AvField
                                  id="patient-noConsentComment"
                                  type="text"
                                  name="noConsentComment"
                                  placeholder="if other, please specify"
                                />
                              </AvGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                  </div>

                  {consentStatus === false && <br />}

                  {
                    consentStatus !== null && (
                      <>
                        <br />
                        <h5 className="text-primary">{t('common.fields.watotoCareId')}</h5>
                        <div className="mt-3">
                          <Row className="justify-content-left">
                            {(isNew || patientEntity?.wcId?.toUpperCase().startsWith('WC')) && (
                              <Col md="6">
                                <AvGroup>
                                  <Label id="override" for="patient-override">
                                    {t('patient.update.watotoCareIdOverride')}
                                  </Label>
                                  <AvInput
                                    id="patient-override"
                                    type="select"
                                    className="form-control"
                                    name="override"
                                    value={overrideWcId}
                                    onChange={(e) => {
                                      setOverrideWcId(e.target.value);
                                    }}
                                  >
                                    <option value="Yes">{t('common.yes')}</option>
                                    <option value="No">{t('common.no')}</option>
                                  </AvInput>
                                </AvGroup>
                              </Col>
                            )}
                            <Col md="6">
                              {(!isNew || overrideWcId === 'Yes') && (
                                <AvGroup>
                                  <Label id="wcId" for="patient-wcId">
                                    {t('common.fields.watotoCareId')}
                                  </Label>
                                  <AvInput
                                    id="patient-wcId"
                                    type="text"
                                    className="form-control"
                                    name="wcId"
                                    disabled={(!isNew && patientEntity?.wcId?.toUpperCase().startsWith('WC')) && overrideWcId !== 'Yes'}
                                    validate={{
                                      required: { value: true, errorMessage: t('common.validation.required') },
                                      maxLength: { value: 16 }
                                    }}
                                  />
                                </AvGroup>
                              )}
                            </Col>
                          </Row>
                        </div>

                        <br />
                        <h5 className="text-primary">{t('patient.update.personalDetailsTitle')}</h5>
                        <div className="mt-3">
                          <Row className="justify-content-left">
                            <Col md="6">
                              <AvGroup>
                                <Label id="rchCardNumber" for="patient-rchCardNumber">
                                  {t('patient.fields.rchCardNumber')}
                                </Label>
                                <AvField
                                  id="patient-rchCardNumber"
                                  type="text"
                                  name="rchCardNumber"
                                  validate={{
                                    required: { value: true, errorMessage: t('common.validation.required') }
                                  }}
                                />
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label id="nidaNumber" for="patient-nidaNumber">
                                  {t('patient.fields.nidaNumber')}
                                </Label>
                                <AvField
                                  id="patient-nidaNumber"
                                  type="text"
                                  name="nidaNumber"
                                />
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label id="firstName" for="patient-firstName">
                                  {t('common.fields.firstName')}
                                </Label>
                                <AvField
                                  id="patient-firstName"
                                  type="text"
                                  name="firstName"
                                  validate={{
                                    required: { value: true, errorMessage: t('common.validation.required') }
                                  }}
                                />
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label id="lastName" for="patient-lastName">
                                  {t('common.fields.lastName')}
                                </Label>
                                <AvField
                                  id="patient-lastName"
                                  type="text"
                                  name="lastName"
                                  validate={{
                                    required: { value: true, errorMessage: t('common.validation.required') }
                                  }}
                                />
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label id="ageRange" for="patient-ageRange">
                                  {t('patient.fields.ageRange')}
                                </Label>
                                <AvInput
                                  id="patient-ageRange"
                                  type="select"
                                  className="form-control"
                                  name="ageRange"
                                  validate={{
                                    required: { value: true, errorMessage: t('common.validation.required') }
                                  }}
                                >
                                  {isNew && <option disabled selected value="">{t('common.selectOption')}</option>}
                                  {ageRangeEntityDetails.map(val => (
                                    <option value={val.id} key={val.id}>
                                      {val.enDescription}
                                    </option>
                                  ))}
                                </AvInput>
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label id="parity" for="patient-parity">
                                  {t('patient.fields.parity')}
                                </Label>
                                <AvInput
                                  id="patient-parity"
                                  type="select"
                                  className="form-control"
                                  name="parity"
                                  value={patientEntity.parity}
                                  validate={{
                                    required: { value: true, errorMessage: t('common.validation.required') }
                                  }}
                                >
                                  {isNew && <option disabled selected value="">{t('common.selectOption')}</option>}
                                  {patientParity.map(val => (
                                    <option value={val} key={val}>
                                      {val}
                                    </option>
                                  ))}
                                </AvInput>
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label for="patient-village">
                                  {consentStatus === true ? 'Pick-up' : 'Home'} {t('common.fields.village')}
                                </Label>
                                <VillageAvTypeahead
                                  labelKey="name"
                                  valueKey="id"
                                  data={villageOptionList()}
                                  placeholder={t('common.fields.village')}
                                  id="patient-village"
                                  loading={villagesLoading}
                                  onChange={(data: any) => setVillageId(data)}
                                  defaultValue={!patientEntity.village ? '' : patientEntity?.village?.name + ' / ' + patientEntity?.village?.council?.name + ' / ' + patientEntity?.village?.council?.parent?.name}
                                  input={{
                                    id: 'patient-village',
                                    name: 'villageId'
                                  }}
                                />
                              </AvGroup>
                            </Col>
                            <Col md="6">
                              <AvGroup>
                                <Label id="villageNotes" for="patient-villageNotes">
                                  {t('patient.fields.villageNotes')}
                                </Label>
                                <AvField
                                  id="patient-villageNotes"
                                  type="text"
                                  name="villageNotes"
                                  validate={!villageId && {
                                    required: { value: true, errorMessage: t('common.validation.required') }
                                  }}
                                />
                              </AvGroup>
                            </Col>
                            {consentStatus === true &&
                              (
                                <Col md="6">
                                  <AvGroup>
                                    <Label id="nearbyLandmarks" for="patient-nearbyLandmarks">
                                      {t('patient.fields.nearbyLandmarks')}
                                    </Label>
                                    <AvField
                                      id="patient-nearbyLandmarks"
                                      type="text"
                                      name="nearbyLandmarks"
                                      placeholder="e.g. opposite village church, next to the village hospital etc."
                                      validate={{
                                        required: { value: true, errorMessage: t('common.validation.required') }
                                      }}
                                    />
                                  </AvGroup>
                                </Col>
                              )
                            }
                            <Col md="6">
                              <AvGroup>
                                <Label id="phoneNumber" for="patient-phoneNumber">
                                  {t('common.fields.phoneNumber')}
                                </Label>
                                <AvField
                                  id="patient-phoneNumber"
                                  type="text"
                                  name="phoneNumber"
                                  validate={consentStatus === true ? {
                                    required: {
                                      value: true,
                                      errorMessage: t('common.validation.required')
                                    }
                                  } : {}}
                                />
                              </AvGroup>
                            </Col>
                          </Row>
                        </div>

                        {
                          consentStatus === true && (
                            <>
                              <h5 className="text-primary mt-3">{t('patient.update.caregiverDetailsTitle')}</h5>
                              <div className="mt-3">
                                <Row className="justify-content-left">
                                  <Col md="6">
                                    <AvGroup>
                                      <Label id="caregiverName" for="patient-caregiverName">
                                        {t('common.fields.caregiverName')}
                                      </Label>
                                      <AvField
                                        id="patient-caregiverName"
                                        type="text"
                                        name="caregiverName"
                                      />
                                    </AvGroup>
                                  </Col>
                                  <Col md="6">
                                    <AvGroup>
                                      <Label id="caregiverPhoneNumber" for="patient-caregiverPhoneNumber">
                                        {t('common.fields.caregiverMobile')}
                                      </Label>
                                      <AvField
                                        id="patient-caregiverPhoneNumber"
                                        type="text"
                                        name="caregiverPhoneNumber"
                                      />
                                    </AvGroup>
                                  </Col>
                                </Row>
                              </div>

                              <h5 className="text-primary mt-3">{t('patient.update.alternateContactTitle')}</h5>
                              <div className="mt-3">
                                <Row className="justify-content-left">
                                  <Col md="6">
                                    <AvGroup>
                                      <Label id="secondaryContactName" for="patient-secondaryContactName">
                                        {t('patient.fields.secondaryContactName')}
                                      </Label>
                                      <AvField
                                        id="patient-secondaryContactName"
                                        type="text"
                                        name="secondaryContactName"
                                      />
                                    </AvGroup>
                                  </Col>
                                  <Col md="6">
                                    <AvGroup>
                                      <Label id="secondaryPhoneNumber" for="patient-secondaryPhoneNumber">
                                        {t('patient.fields.secondaryPhoneNumber')}
                                      </Label>
                                      <AvField
                                        id="patient-secondaryPhoneNumber"
                                        type="text"
                                        name="secondaryPhoneNumber"
                                      />
                                    </AvGroup>
                                  </Col>
                                </Row>
                              </div>

                              <h5 className="text-primary mt-3">{t('patient.update.additionalDetailsTitle')}</h5>
                              <WatotocareEntityFormGroup
                                prefix="patient-enrollment"
                                entities={patientEnrollmentMasterEntities}
                                initialValues={entityFormInitialValues}
                                onChange={(values) => setEntityFormSelectedValues(values)}
                              />
                            </>
                          )
                        }

                        <br />
                        <Button tag={Link} id="cancel-save" to="/patient" replace color="info">
                          <FontAwesomeIcon icon="arrow-left" />
                          &nbsp;
                          <span className="d-none d-md-inline">{t('common.actions.back')}</span>
                        </Button>
                        &nbsp;
                        <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                          <FontAwesomeIcon icon="save" />
                          &nbsp; {t('common.actions.save')}
                        </Button>
                      </>
                    )
                  }
                </>
              )}
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  patientEntity: storeState.patient.entity,
  loading: storeState.patient.loading,
  updating: storeState.patient.updating,
  updateSuccess: storeState.patient.updateSuccess,
  errorMessage: storeState.patient.errorMessage,
  userCountryId: storeState.authentication.userCountryId,
  villages: storeState.village.entities,
  villagesLoading: storeState.village.loading,
  watotoCareEntityList: storeState.watotoCareEntity.masterEntities,
  watotoCareEntitiesByGroup: storeState.watotoCareEntity.masterEntitiesByGroup
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
  resetWatotoCareEntities,
  getVillages,
  getMasterEntitiesByEnumNames,
  getMasterEntitiesByGroupNames
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PatientUpdate);
